import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { currentUser: null },
  reducers: {
    setCurrentUser(state, action) {
      return { ...state, currentUser: action.payload };
    },
  },
});

export default userSlice.reducer;
export const { setCurrentUser } = userSlice.actions;
